"use client"

import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:rounded-lg group-[.toaster]:border group-[.toaster]:border-line group-[.toaster]:bg-surface group-[.toaster]:text-ink group-[.toaster]:shadow-md",
          title: "group-[.toast]:font-medium",
          description: "group-[.toast]:text-ink-muted",
          actionButton:
            "group-[.toast]:rounded-md group-[.toast]:bg-ink group-[.toast]:text-ink-inverse",
          cancelButton:
            "group-[.toast]:rounded-md group-[.toast]:bg-surface-2 group-[.toast]:text-ink-muted",
          error: "group-[.toaster]:border-danger",
          success: "group-[.toaster]:border-success",
        },
      }}
      {...props}
    />
  )
}
